// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ############################################################

// Initial state
const initialState = {
	sharedGalleryViewType: "grid",
	homepageViewType: "list",
};

// ############################################################

// Slice
const globalViewTypesSlice = createSlice({
	name: "global/viewTypes",
	initialState,
	reducers: {
		setSharedGalleryViewType: (state, action) => {
			state.sharedGalleryViewType = action.payload;
		},
		setHomepageViewType: (state, action) => {
			state.homepageViewType = action.payload;
		},
	},
});

// ############################################################

export default globalViewTypesSlice.reducer;

// ** Actions
export const { setSharedGalleryViewType, setHomepageViewType } =
	globalViewTypesSlice.actions;

// ############################################################
